import React, { useState, useRef } from "react";
import { Dropdown } from "primereact/dropdown";
import TarifasTable from "../components/TarifasTable";
import { Button } from "primereact/button";
import { useGlobalContext } from "../Config";
import Loader from "../components/Loader.js";
import { Toast } from 'primereact/toast';

const empresas = [
  { name: "ALTAMIRA", value: "ALTAMIRA" },
  { name: "LA SIEMBRA", value: "LA SIEMBRA" },
];
const Tarifa = (props) => {
  const toast = useRef(null);
  const [empresa, setEmpresa] = useState("");
  const [idEmpresa, setIdEmpresa] = useState(""); //idEmpresa será utilizado con el back posteriormente
  const [mostrarTitulo, setMostrarTitulo] = useState(false);
  const [displayDialog, setDisplayDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedTarifa, setSelectedTarifa] = useState("");
  const [newTarifa, setNewTarifa] = useState("");
  const { baseUrl } = useGlobalContext();
  const idUsuario = sessionStorage.getItem("usuario_id");
  const handleChangeEmpresa = (e) => {
    const selectedEmpresa = e.value;
    setEmpresa(selectedEmpresa);
    setIdEmpresa(selectedEmpresa.id);
  };

  const handleCloseDialog = () => {
    setDisplayDialog(false);
    setSelectedTarifa(null);
    setNewTarifa("");
  };

  const handleBuscarClick = () => {
    setMostrarTitulo(true);
  };

  const fetchData = async (url) => {
    const requestOptions = {
      method: "GET",
      headers: new Headers(),
      redirect: "follow",
    };

    const response = await fetch(url, requestOptions);

    if (!response.ok) {
      throw new Error(
        `Network response was not ok. Status: ${response.status}`
      );
    }

    return response.json();
  };
  const getTarifasByEmpresa = async (empresa) => {
    try {
      setLoading(true);
      const url = `${baseUrl}getTarifasByEmpresa?empresa=${empresa}`;
      const data = await fetchData(url);
      handleTarifasResponse(data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleTarifasResponse = (data) => {
    setTarifas(data);
    setMostrarTitulo(true);
  };

  // const createCotizacion = async () => {
  //   try {
  //     var myHeaders = new Headers();
  //     myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
  //     var urlencoded = new URLSearchParams();

  //     var requestOptions = {
  //       method: "POST",
  //       headers: myHeaders,
  //       body: urlencoded,
  //       credentials: "include",
  //       redirect: "follow",
  //     };
  //     const url = deactivateTarifa();
  //     fetch(url, requestOptions)
  //       .then((response) => {
  //         console.log(response);
  //         if (response.ok) {
  //           alert("La tarifa se actualizó correctamente");
  //         } else {
  //           alert("No fue posible actualizar la tarifa");
  //           return;
  //         }
  //       })
  //       .then((result) => console.log(result))
  //       .catch((error) => console.log("error", error));
  //   } catch (error) {
  //     console.error(error);
  //     alert("Hubo un error");
  //   }
  // };
  const handleUpdateTarifa = async () => {
    try {
      let indicador;
      switch (selectedTarifa.tipo) {
        case "producto":
          indicador = "Producto";
          break;
        case "subproducto":
          indicador = "Subproducto";
          break;
        case "servicio":
          indicador = "Servicio";
          break;
        default:
          indicador = "";
      }
      const deactivateTarifa = () => {
        return `${baseUrl}deactivateTarifa${indicador}?id=${selectedTarifa.id}&idUsuario=${idUsuario}`;
      };

      const updateTarifa = () => {
        return `${baseUrl}insertTarifa${indicador}?idTipo${indicador}=${selectedTarifa.id_tipo}&idEmpresa=${selectedTarifa.id_empresa}&tarifaBase=${newTarifa}&idUsuario=${idUsuario}&moneda=${selectedTarifa.moneda}`;
      };

      const requestOptions = {
        method: "POST",
        redirect: "follow",
      };
      if (newTarifa === 0) {
        const urlDeactivate = deactivateTarifa();
        const response = await fetch(urlDeactivate, requestOptions);
        if (response.ok) {
          toast.current.show({ severity: 'success', summary: 'Success', detail: 'La tarifa se actualizó correctamente' });
        } else {
          throw new Error("No fue posible actualizar la tarifa");
        }
      } else {
        const urlDeactivate = deactivateTarifa();
        const urlInsert = updateTarifa();

        const deactivateResponse = await fetch(urlDeactivate, requestOptions);
        if (!deactivateResponse.ok) {
          throw new Error("No fue posible desactivar la tarifa existente");
        }

        const insertResponse = await fetch(urlInsert, requestOptions);
        if (insertResponse.ok) {
          toast.current.show({ severity: 'success', summary: 'Success', detail: 'La tarifa se actualizó correctamente' });
        } else {
          throw new Error("No fue posible actualizar la tarifa");
        }
      }
      await getTarifasByEmpresa(empresa);
      setDisplayDialog(false);
    } catch (error) {
      await getTarifasByEmpresa(empresa);
      console.error(error);
      toast.current.show({ severity: 'error', summary: 'Error', detail: 'Hubo un error al actualizar la tarifa' });
      setDisplayDialog(false);
    }
  };

  const templateButton = (rowData) => {
    return (
      <div>
        <Button
          icon="pi pi-pencil"
          className="p-button-rounded p-button-success p-button mr-2 mb-2 mt-2"
          outlined
          onClick={() => {
            setSelectedTarifa(rowData);
            setNewTarifa(null)
            setDisplayDialog(true);
          }}
          label="Editar"
        />
        {""}
      </div>
    );
  };
  ////////MOCK DATA////////

  const [tarifas, setTarifas] = useState([]);

  ///////MOCK DATA////////

  return (
    <div className="grid">
      <Toast ref={toast} />
      <div className="col-12">
        <div className="card">
          <h4>Gestión de Tarifas</h4>
          <div className="p-field">
            <label htmlFor="empresa">Seleccione Empresa: </label>
            <Dropdown
              id="state"
              value={empresa}
              onChange={async (e) => {
                setEmpresa(e.value);
                try {
                  await getTarifasByEmpresa(e.value);
                } catch (error) {
                  console.error("Error occurred:", error);
                }
              }}
              options={empresas}
              optionLabel="name"
              placeholder="Seleccione Empresa"
              className="p-inputtext-sm"
            ></Dropdown>
          </div>
        </div>
        {mostrarTitulo && empresa && (
          <>
            {loading ? (
              <>
                <Loader />
              </>
            ) : (
              <>
                <TarifasTable
                  tarifas={tarifas}
                  displayDialog={displayDialog}
                  setDisplayDialog={setDisplayDialog}
                  selectedTarifa={selectedTarifa}
                  setSelectedTarifa={setSelectedTarifa}
                  newTarifa={newTarifa}
                  setNewTarifa={setNewTarifa}
                  handleCloseDialog={handleCloseDialog}
                  templateButton={templateButton}
                  handleUpdateTarifa={handleUpdateTarifa}
                ></TarifasTable>{" "}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Tarifa;
